import { B2CIAMErrorResponse } from 'types/api/b2ciam';
import { IdLookupResponse } from 'types/api/id-lookup';
import { OrchestratorErrorResponse } from 'types/api/orchestrator';
import { ErrorResponse, FetchResponseValue, Headers, ParsedErrorResponse } from 'types/fetch';
import { getHeader } from './fetch';

export function getLockoutFlow(
  response: FetchResponseValue<
    IdLookupResponse,
    B2CIAMErrorResponse<{ vmg_code: string } | undefined>
  >
) {
  if (!response.ok) {
    const errorResponse = response.errorObject;
    const error = errorResponse.error_details?.[0].error;
    const vmgCode = errorResponse.data?.vmg_code;

    if (error === 'account_locked') {
      return 'account-locked';
    }

    if (error === 'device_locked' || vmgCode === 'VMG-00231') {
      return 'device-locked';
    }

    return null;
  }

  const action = response.data.data?.actions?.[0];

  if (action === 'ABANDON') {
    return 'device-locked';
  }

  if (action === 'GUEST') {
    return 'account-locked';
  }

  return null;
}

export function getOrchestratorLockoutFlow(
  response: ParsedErrorResponse<OrchestratorErrorResponse>
) {
  const { message } = response.errorObject;

  if (message === 'account_locked') {
    return 'account-locked';
  }

  if (message === 'device_locked') {
    return 'device-locked';
  }

  if (message === 'acct_inaccessible') {
    return 'account-inaccessible';
  }

  return null;
}

export function getLockoutFlowLegacy(
  response: ParsedErrorResponse<ErrorResponse> & { headers: Headers }
) {
  const { errorCode, httpStatus } = response;
  const xAppEventCode = getHeader(response, 'x-app-event-code');

  if (
    (httpStatus === 400 && errorCode === 'invalid_grant_devicelockout') ||
    (httpStatus === 423 && (errorCode === 'VMG-00230' || errorCode === 1087)) ||
    xAppEventCode === 'VMG-00230'
  ) {
    return 'device-locked';
  }

  if (
    (httpStatus === 400 &&
      // VCO-14530: /token call failure in ACCOUNT_LOCKED scenario uses response.error
      errorCode === 'invalid_grant_loginlockout') ||
    httpStatus === 423 ||
    errorCode === 'VMG-002' ||
    xAppEventCode === 'VMG-00240'
  ) {
    return 'account-locked';
  }

  return null;
}
